import styled from 'styled-components';

export const ValueContainer = styled.div<{
  $isReadOnly?: boolean;
}>`
  display: flex;
  column-gap: 4px;
  word-break: break-word;
  ${({ $isReadOnly }) =>
    !$isReadOnly &&
    `
    &:hover {
      cursor: pointer;
    }
  `}
`;
